export default "__VITE_ASSET__BCkA$PUj__"